<template>
    <list-widget title="추천인(뷰어) 코드" max-width="280" #default="{ attrs }">
        <autocomplete-viewer v-model="query['_viewer']" v-bind="attrs" :item-text="itemText" placeholder="전체" dense flat solo hide-details clearable @input="emit" />
    </list-widget>
</template>

<script>
import AutocompleteViewer from "../dumb/autocompletes/autocomplete-viewer.vue";
import ListWidget from "../dumb/list/list-widget.vue";

const initQuery = (query = {}) => ({
    ...(query || {}),

    ["_viewer"]: query?.["_viewer"] || null,
});

// 추천인코드(refid)를 앞세운다 — 협력사쪽에서 부르는 이름이 코드이기 때문이다.
// 코드가 지정되지 않은 뷰어도 있으므로 빈 값은 걷어낸다.
const itemText = ({ refid, username, name } = {}) => [refid, username, name].filter((item) => item).join(" / ");

export default {
    components: {
        AutocompleteViewer,
        ListWidget,
    },
    data: () => ({
        query: initQuery(),

        itemText,
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;
            delete query["page"];
            if (!query["_viewer"]) delete query["_viewer"];
            this.$router.push({ query });
        },
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped></style>
